import styled from 'styled-components'

export default styled.div`
  font-size: 14px;
  line-height: 18px;
`
